<template>
  <div class="UseFlow">
    <div class="inner_center">
      <div class="headline flow">使用流程</div>
      <div class="flow-content">
        <div
          v-for="(v,i) in INTRO_COMPANY.USE_FLOW.STEP_LIST"
          :key="i"
          :class="'flow-item' + (i+1)"
          class="flow-item">
          <div class="txt-label">{{ v.label }}</div>
          <div class="txt-value">{{ v.value }}</div>
        </div>
      </div>

      <div class="headline filing">
        正版保障 • 国家版权局认证备案
      </div>
      <div class="subhead">
        潮国创意作品通过国家版权局备案认证，通过数字化存证以及版权登记方式，以确保作品权利归属明确，来源可追溯。<br>
        潮国创意用户获得作品授权后可下载企业商用授权书，有效避免版权风险和纠纷。
      </div>

      <div class="certificate-box">
        <i class="zs1" />
        <i class="zs2" />
      </div>
    </div>
  </div>
</template>

<script>
import {INTRO_COMPANY} from "@/constant/intro/INTRO_COMPANY";

export default {
  name: "UseFlow",
  data(){
    return{
      INTRO_COMPANY
    }
  }
}
</script>

<style lang="scss" scoped>
@for $i from 1 to 5 {
  .flow-item#{$i} {
    @include BgImage(300px, 333.33px, 'introduce/company/UseFlow/flow-item#{$i}.png');
  }
}


.UseFlow {
  width: 100%;
  //height: 1130px;
  background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 48%, #F5F6FA 72%, #F5F6FA 100%);
  padding-bottom: 58px;

  .inner_center {
    width: 1200px !important;
    .headline {
      font-size: 32px;
      font-weight: bold;
      color: #2D2B33;
      line-height: 42px;
      letter-spacing: 1px;
      text-align: center;

      &.flow {
        padding: 56px 0 46px;
      }

      &.filing {
        margin-bottom: 12px;
      }
    }

    .flow-content {
      margin-bottom: 98px;

      .flow-item{
        padding: 58px 42px 0 45px;
        box-sizing: border-box;

        .txt-label{
          font-size: 17px;
          font-weight: bold;
          color: #424866;
          line-height: 22px;
          letter-spacing: 1px;
          margin-bottom: 6px;
        }
        .txt-value{
          font-size: 13px;
          color: #596088;
          line-height: 18px;
        }
      }
    }

    .subhead{
      font-size: 14px;
      color: #424866;
      line-height: 24px;
      text-align: center;

    }

    .certificate-box{
      margin: 40px auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .zs1{
        display: inline-block;
        @include BgImage(420px,338px,'introduce/company/UseFlow/certificate1.png');
        margin-right: 88px;
      }
      .zs2{
        display: inline-block;
        @include BgImage(430px,346px,'introduce/company/UseFlow/certificate2.png');
      }
    }
  }
}
</style>
